import { createPortal } from 'react-dom'

/** Rend ses enfants directement dans document.body via createPortal.
 *  Toute modale wrappée par <Portal> sort de la hiérarchie <main>,
 *  évitant les problèmes d'overflow et de z-index (tab bar, etc.). */
export function Portal({ children }: { children: React.ReactNode }) {
  return createPortal(children, document.body)
}
